import React from 'react';
import PropTypes from 'prop-types';
import { toggleDrawer, openHome, openResident } from '../../reducers/ui-control';
import { drawerIsOpen } from '../../util/selectors';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Icon from '@material-ui/core/Icon'
import DrawerItem from '../../components/drawer-item'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
const DrawerModule = ({ toggleDrawer, drawerIsOpen, openHome, openResident, children }) => (
  <Drawer open={drawerIsOpen} onClose={toggleDrawer}>
    <div
      tabIndex={0}
      role="button"
      onClick={toggleDrawer}
      onKeyDown={toggleDrawer}
    />
    <List component="nav">
      <ListItem>

        <Typography variant="headline" gutterBottom>
          Guest Pass
      </Typography>
      </ListItem>
      <Divider />
      <DrawerItem text="Home" linkTo="/" >
        <Icon>
          flight_land
        </Icon>
      </DrawerItem>
      <DrawerItem text="Resident" linkTo="/resident">
        <Icon>
          home
        </Icon>
      </DrawerItem>
      <DrawerItem text="Guest" linkTo="/guest">
        <Icon>
          how_to_reg
        </Icon>
      </DrawerItem>
      <DrawerItem text="Gate" linkTo="/scan">
        <Icon>
          settings_remote
        </Icon>
      </DrawerItem>
      <DrawerItem text="Settings" linkTo="/settings">
        <Icon>
          settings
        </Icon>
      </DrawerItem>
    </List>
  </Drawer>
);

DrawerModule.propTypes = {
  drawerIsOpen: PropTypes.bool.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
  openHome: PropTypes.func.isRequired,
  openResident: PropTypes.func.isRequired
}
const mapStateToProps = state => ({
  drawerIsOpen: drawerIsOpen(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  toggleDrawer,
  openHome,
  openResident
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DrawerModule);


// WEBPACK FOOTER //
// ./src/modules/drawer/index.js